import { render, staticRenderFns } from "./right-policy-info.vue?vue&type=template&id=5b46115a&scoped=true&"
import script from "./right-policy-info.vue?vue&type=script&lang=js&"
export * from "./right-policy-info.vue?vue&type=script&lang=js&"
import style0 from "./right-policy-info.vue?vue&type=style&index=0&id=5b46115a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46115a",
  null
  
)

export default component.exports